import { createReducer, on } from '@ngrx/store';
import { Language } from '../../models/language.model';
import { LanguagesActions } from './languages.actions';

export const initialState: ReadonlyArray<Language> = [];

export const LanguagesReducer = createReducer(
    initialState,
    on(LanguagesActions.removeLanguage, (state, { languageId }) =>
        state.filter((language: Language) => language.id !== languageId)
    ),
    on(LanguagesActions.addLanguage, (state, { language }) => {
        if (state.some((l: Language) => l.id === language.id)) return state;
        return [...state, language];
    }),
    on(LanguagesActions.addLanguages, (state, { languages }) => {
        return [...state, ...languages];
    })
)